/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { getBrowserGlobals } from "app/client/lib/browserGlobals";
import { TestState } from "app/common/TestState";

const G = getBrowserGlobals("window");

export function setTestState(state: Partial<TestState>) {
  if (!G.window.testGrist) {
    G.window.testGrist = {};
  }
  Object.assign(G.window.testGrist, state);
}

export function getTestState(): TestState {
  if (!G.window.testGrist) {
    G.window.testGrist = {};
  }
  return G.window.testGrist;
}
